(function () {
  if (customElements.get('yugen-cinematic-hero')) return;

  var SCROLL_TARGETS = {
    explorer: 'yugen-product-explorer, .ype-section, [id^="YPE-"]',
    product: '[id^="ProductInfo-"], .product__info-container, [id^="MainProduct-"]',
  };

  class YugenCinematicHero extends HTMLElement {
    connectedCallback() {
      // Trigger the on-load reveal + slow zoom. rAF lets the initial
      // (pre-animation) state paint first so the transition runs.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-ready'));
      });

      this.ctas = [...this.querySelectorAll('[data-ych-cta]')];
      this.onCtaClick = this.onCtaClick.bind(this);
      this.ctas.forEach((cta) => cta.addEventListener('click', this.onCtaClick));
    }

    disconnectedCallback() {
      this.ctas.forEach((cta) => cta.removeEventListener('click', this.onCtaClick));
    }

    resolveTarget(link) {
      const href = link.getAttribute('href') || '';
      const hash = href.charAt(0) === '#' ? href.slice(1) : href.split('#')[1];
      if (hash) {
        const byId = document.getElementById(hash);
        if (byId) return byId;
      }

      const kind = link.getAttribute('data-ych-scroll');
      const selector = SCROLL_TARGETS[kind];
      if (!selector) return null;
      return document.querySelector(selector);
    }

    onCtaClick(event) {
      const target = this.resolveTarget(event.currentTarget);
      if (!target) return;

      event.preventDefault();

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduce ? 'auto' : 'smooth',
        block: 'start',
      });

      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  customElements.define('yugen-cinematic-hero', YugenCinematicHero);
})();
